// P1 counterparty-contacts list contract.
//
// Extends phase-p1.ts (which owns upsert) with the read-side contract.
// Split to keep phase-p1.ts under the 300-line budget.

import { Schema } from 'effect';

import { EmailAddress, IsoDateTimeUtc } from '@finnest/core/effect';

import { regulatoryEcosystemSchema } from '../../opin/source/source-mode.ts';
import { ParticipantId } from '../vocabulary/ids/branded-ids.ts';

export const onboardingListCounterpartyContactsResponseSchema = Schema.Struct({
  contacts: Schema.Array(
    Schema.Struct({
      id: Schema.NonEmptyString,
      // The participant / authorisation-server id (e.g. `as_1`) the operator
      // registered. P5 selects counterparties by THIS id (counterpartyAuthServerIds),
      // never by the generated contact primary key `id`.
      participantId: ParticipantId,
      // The counterparty's ecosystem. P5 filters the picker by the active run
      // ecosystem so an OPIN run can never target an OFB authorisation server
      // (or vice versa).
      ecosystem: regulatoryEcosystemSchema,
      name: Schema.NonEmptyString,
      role: Schema.NonEmptyString,
      email: Schema.optionalKey(EmailAddress),
      lastResponseAt: Schema.optionalKey(IsoDateTimeUtc),
    }),
  ),
}).annotate({
  title: 'Power onboarding list counterparty contacts response',
  description: 'Lists P5-targeted counterparty contacts for a customer.',
});
export type OnboardingListCounterpartyContactsResponse =
  typeof onboardingListCounterpartyContactsResponseSchema.Type;
